/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'

import './Modal.css'

export default class Modal extends Component {

    constructor(props) {
        super(props)

        this.close = this.close.bind(this)
        this.keyPressed = this.keyPressed.bind(this)
    }

    keyPressed(event) {
        switch (event.keyCode) {
        case 27: //escape
            this.close(event)
            break
        case 13: //enter
            this.submit(event)
            break
        default:
            break
        }

        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation()
    }

    renderTitle() {
        if(this.props.titleRenderFunc) return this.props.titleRenderFunc()
        return (
            <div className="heading-text">{this.props.title}</div>
        )
    }

    render() {
        const closeClass = this.props.open ? 'opened' : 'closed'
        const whoopsClass = this.props.whoops ? 'whoops' : ''
        const className = this.props.className ? this.props.className : ''
        const hideCloseBtnStyle   = this.props.hideCloseBtn ? { display: 'none' } : null

        return (
            <div className={`OldModal ${closeClass} ${whoopsClass} ${className}`} onClick={this.close}>
                <div className="Modal-wrapper" onClick={(e) => { e.stopPropagation(); return false }}
                    onKeyDown={this.keyPressed}>
                    <div className="Modal-heading">
                        {this.renderTitle()}
                        <div style={hideCloseBtnStyle} className="close-button" onClick={this.close}>Close</div>
                    </div>
                    <div className="Modal-body">{this.props.children}</div>
                </div>
            </div>
        )
    }

    submit(event) {
        this.props.onRequestSubmit && this.props.onRequestSubmit(event)
    }

    close(event) {
        this.props.onRequestClose && this.props.onRequestClose(event) 
    }
}
